'use client';

export { useRouter } from 'nextjs-toploader/app';
export { useRouter as useSilentRouter } from 'next/navigation';
